/**
 * @file User / material analysis UI — pages/Dashboard/User/MaterialAnalysisInput/utils/embodiedCarbonFactorLegend.ts.
 */

import type { EmbodiedCarbonFactorStats } from "../../../../../services/materialAnalysisService";

/** Type definition — Red Dot Kind. */
export type RedDotKind = "max" | "ci_upper";

/** Exported function — resolve Red Dot Kind. */
export function resolveRedDotKind(
  count: number,
  method?: EmbodiedCarbonFactorStats["method"]
): RedDotKind {
  if (method === "UPPER_95_CI") return "ci_upper";
  if (method === "MAX_FOR_SMALL_SAMPLE") return "max";
  return count > 5 ? "ci_upper" : "max";
}

/** Legend label for the min-to-recommended range bar (n-based). */
export function embodiedCarbonRangeLegendText(count: number): string {
  return count > 5 ? "95% confidence interval" : "min - max range";
}

/** Exported function — red Dot Legend Text. */
export function redDotLegendText(kind: RedDotKind): string {
  return kind === "ci_upper"
    ? "ICoMEC Embodied Carbon Factor - Upper Bound of 95% Confidence Interval"
    : "ICoMEC Embodied Carbon Factor - Maximum available value";
}

/** Exported function — red Dot Hover Suffix. */
export function redDotHoverSuffix(kind: RedDotKind): string {
  return kind === "ci_upper"
    ? "Upper bound of 95% CI"
    : "Maximum available value";
}
